import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { LoginService } from 'src/app/login.service';
import { TranslatorService } from 'src/app/translator.service';

@Component({
  selector: 'app-switchuser',
  templateUrl: './switchuser.component.html',
  styleUrls: ['./switchuser.component.scss'],
})
export class SwitchuserComponent implements OnInit {
  @Input() style;
  @Input() message;

  public flags = [];
  constructor(public translator: TranslatorService, public loginService: LoginService, public modalCtrl: ModalController) { }

  ionViewWillEnter() {
    if (this.message === undefined) {
      this.message = this.translator.translate('idx', '*Selecteaza membrul familiei activ!');
    }

  }
  ngOnInit() {
  }
  changeStudent(idx) {
    this.modalCtrl.dismiss(idx);
  }
}
